/**
 * PHARMAKON — Trésorerie TWP-60 · the cashier's financial visibility (BRIEF_POS §2.1, TO-15), browser twin
 * of the server CONFIG.
 *
 * « Own count only »: under the default the server answers a CAISSIER the NUMBER of his sales and no
 * amount — a hidden figure is ABSENT from the payload (never 0, RC-67) and the payload names the hidden
 * figures in `visibilite.masques`. The screens read that cue to say « Masqué » where a figure would be;
 * they never decide what is hidden (the server is the authority, TD-347).
 *
 * Owner of the values: `apps/server/src/config/visibilite-caissier.config.js`. This file is a twin, not
 * an import, because the API image is built from apps/server alone. The server test
 * `src/__tests__/visibilite-caissier.parity.test.js` imports both and fails on any drift — change a value
 * there first, then here.
 */

/** The five figures a P / M may show to the cashier (TD-347), as the server names them in `visibilite.masques`. */
export const DROIT_VISIBILITE = Object.freeze({
  NB_VENTES: "nb_ventes",
  TOTAL_VENTES: "total_ventes",
  FAMILLES: "familles",
  ESPECES: "especes",
  AUTRES_TOTAUX: "autres_totaux",
});

/** TWP-61 — the Trésorerie settings column of each figure (`caissier_voit_*`; NULL = the default « own count only »). */
export const COLONNE_PARAMETRE_VISIBILITE = Object.freeze({
  nb_ventes: "caissier_voit_nb_ventes",
  total_ventes: "caissier_voit_total_ventes",
  familles: "caissier_voit_familles",
  especes: "caissier_voit_especes",
  autres_totaux: "caissier_voit_autres_totaux",
});

/** TWP-61 — the French name of each figure (the P / M « Visibilité du caissier » section). */
export const LIBELLES_DROIT_VISIBILITE = Object.freeze({
  nb_ventes: "Nombre de ses ventes",
  total_ventes: "Total de ses ventes",
  familles: "Totaux par famille (Médicament, Parapharmacie, Cosmétique, Orthopédie, Autres)",
  especes: "Espèces de la caisse",
  autres_totaux: "Autres totaux (par mode de paiement, remises, versement)",
});

/** TD-348 — the plain consequence the settings section shows while the cash is hidden. */
export const LIBELLE_COMPTAGE_AVEUGLE_IMPOSE = "Espèces masquées : le caissier clôture à l'aveugle.";

/** The recap's family buckets in reading order (RC-CP-11: Orthopédie and « Autres » included). */
export const BUCKETS_RECAP = Object.freeze(["ca_medicament", "ca_parapharmacie", "ca_cosmetique", "ca_orthopedie", "ca_autres"]);

/** The sentence a screen shows where a figure is absent by the policy. */
export const LIBELLE_MONTANT_MASQUE = "Montant masqué par le responsable.";

/** The word a figure's cell shows when the policy hides it (never « 0,00 DA »). */
export const LIBELLE_MONTANT_MASQUE_TICKET = "masqué";
